import React from "react";
import { LoggedInUser } from "@mksap/types/loggedInUser";
import { WebLoginForm } from "./WebLoginForm";
import { Card, Container } from "../ui/MksapReactBootstrap";
import imagePath from "@mksap/utils/imagePath";
import { LandingPageCarousel } from "./LandingPageCarousel";
import { Slide } from "./slideType";
// import { Button } from "../ui/Button";

interface LandingPageProps {
	onLogIn(userData: LoggedInUser): void;
	showComingSoonMessage: boolean;
}

export const LandingPage: React.FC<LandingPageProps> = ({
	onLogIn,
	// showComingSoonMessage,
}) => {
	const slides: Slide[] = [
		{
			image: imagePath("placeholder-screenshot-syllabus.png"),
			alt: `Syllabus page listing Internal Medicine content areas such as Cardiovascular Medicine,
			Common Symptoms, and Dermatology, with links to resume progress and view the table of
			contents.`,
			text: (
				<div role="group" className="ms-2">
					<h2 className="h5" id="MKSAP Syllabus">
						Created by physicians, for physicians
					</h2>
					<p>
						A comprehensive resource for clinical knowledge needed in Internal
						Medicine.
					</p>
				</div>
			),
		},
		{
			image: imagePath("placeholder-screenshot-questionbank.png"),
			alt: `Question Bank dashboard showing 57 completed questions with percentage correct
			and incorrect, options to answer shuffled questions or view custom quizzes, and
			access to saved question sets.`,
			text: (
				<div role="group" className="ms-2">
					<h2 className="h5" id="MKSAP Syllabus">
						A Robust Question Bank
					</h2>
					<p>
						Case-based clinical questions with single-best-answer options and
						detailed critiques.
					</p>
				</div>
			),
		},
		{
			image: imagePath("placeholder-screenshot-learningplan.png"),
			alt: `Learning Plan dashboard showing five selected topics with progress indicators
			for tasks and questions answered, plus an option to add new topics.`,
			text: (
				<div role="group" className="ms-2">
					<h2 className="h5" id="MKSAP Syllabus">
						Personalized Learning Plan
					</h2>
					<p>
						Target topics to deepen your understanding with related content and
						learning links.
					</p>
				</div>
			),
		},
		{
			image: imagePath("placeholder-screenshot-core.png"),
			alt: `CORE dashboard displaying certificate progress across content areas, earned badges
			with dates, and a progress bar tracking advancement toward the CORE certificate.`,
			text: (
				<div role="group" className="ms-2">
					<h2 className="h5" id="MKSAP Syllabus">
						Confirmation of Relevant Education (CORE&trade;)
					</h2>
					<p>
						Demonstrate your continuous learning with clinically relevant
						question sets.
					</p>
				</div>
			),
		},
	];

	return (
		<main className="bg-primary bg-gradient center">
			<h1 className="visually-hidden">ACP MKSAP</h1>
			<div className="web-login-form top-0 start-0 bottom-0 end-0">
				<Container fluid="xl" className="top-50 start-50">
					<div className="row justify-content-center m-lg-5">
						<div className="col-md-6 col-lg-5 col--form ps-sm-4 py-4">
							{/*showComingSoonMessage ? (
						<div className="col-md-6 col-lg-5 col--form ps-sm-4 py-4">
							{showComingSoonMessage ? (
								<div className="coming-soon">
									<div className="my-4">
										<img
											src={imagePath("acp-logo-horiz-w.svg")}
											className=""
											alt="ACP MKSAP"
										/>
									</div>
									<h1 className="h2 text-white">
										ACP MKSAP launches{" "}
										<span className="text-nowrap">February 3, 2025</span>
									</h1>
									<div className="mt-3">
										<Button
											variant="outline-light"
											className=""
											href="https://www.acponline.org/featured-products/acp-mksap"
										>
											Learn More
										</Button>
									</div>
								</div>
							) : ( */}
							<Card className="h-100 d-flex flex-column pt-4 pt-md-0">
								<img
									src={imagePath("acp-mksap-logo-horiz-4c-tagline.svg")}
									className="card-img-top pt-4 px-3"
									alt="ACP MKSAP"
								/>
								<Card.Body>
									<WebLoginForm onLogIn={onLogIn} />
								</Card.Body>
							</Card>
							{/* )} */}
						</div>
						<div
							className="col col--slider h-100 pe-sm-4 py-4"
							role="region"
							aria-label="Carousel"
						>
							<LandingPageCarousel slides={slides} />
						</div>
					</div>
				</Container>
			</div>
		</main>
	);
};
